import React, { useState } from "react";

function withDialogState(WrappedComponent) {
    return function WithDialogState(props) {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
      <WrappedComponent
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
        {...props}
      />
    );
  };
}

export default withDialogState;
